/** HEL-2250 / HEL-2280: in-memory Helen clinic JWT for LocalServer Token header. */

let memoryAuthToken = "";

export function setMemoryAuthToken(token) {
  memoryAuthToken = token || "";
}

export function getMemoryAuthToken() {
  return memoryAuthToken || "";
}

/** Attach Token / Link headers expected by LocalServer JWT gates. */
export function attachLocalServerAuthHeaders(config) {
  const token = memoryAuthToken || "";
  const link = localStorage.getItem("link") || "";
  if (!config.headers) config.headers = {};
  if (token) {
    config.headers.Token = token;
    config.headers.token = token;
  }
  if (link) {
    config.headers.Link = link;
  }
  return config;
}
